import styled, { keyframes } from 'styled-components';
const showToastrAnimation = keyframes `
 0% { transform: translateY(-1000px); }
 100% { transform: translateY(0); }
`;
const ToastrWrapperBase = styled.div `
  margin: 0 auto;
  padding: 8px;
  animation: ${showToastrAnimation};
  animation-duration: 1s;
  animation-iteration-count: 1;
`;
const ToastrWrapperContent = styled.div `
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.colors.ui01};
  border-radius: 8px;
  box-shadow: ${({ theme }) => theme.shadows.large};
  cursor: pointer;
  display: grid;
  grid-template-columns: min-content 1fr min-content;
  grid-column-gap: 8px;
  width: fit-content;

  svg {
    display: inline-block;
    flex-shrink: 0;
  }

  .toast-icon {
    margin-top: -1px;
  }
`;
export { ToastrWrapperBase, ToastrWrapperContent };
//# sourceMappingURL=ToastrWrapperBase.js.map